import * as numeral from "numeral";
import * as currencysymbol from "currency-symbol";
import * as moment from "moment";

export function formatAmount(amount) {
  return numeral(amount).format("0,0");
}
export function formatCurrencyAmount(amount, withCurrency) {
  return (
    currencysymbol.symbol(withCurrency === "GHS" ? "GHC" : "NGN") +
    numeral(amount).format("0,0")
  );
}

export function sumBookingPrice(data) {
  if (!data) {
    return formatCurrencyAmount(0);
  }
  const rent = Number(data.rent);
  const service_charge = Number(data.service_charge);
  const discount = Number(data.discount);
  const booking_fee = Number(data.booking_fee);
  const vat = Number(data.vat);
  const security_deposit = Number(data.security_deposit);
  const eviction_security_deposit = Number(data.eviction_security_deposit);
  const commission = Number(data.commission);
  const agencyFee = Number(data.agencyFee);
  const legalFee = Number(data.legalFee);
  return formatCurrencyAmount(
    +rent +
      +service_charge +
      +vat +
      +security_deposit +
      +booking_fee +
      +eviction_security_deposit +
      +agencyFee +
      +legalFee +
      +commission -
      +discount,
    data.currency
  );
}

// export function sumBookingPriceWithoutCurrency(data) {
//   if (!data) {
//     return formatCurrencyAmount(0);
//   }
//   const rent = Number(data.rent);
//   const service_charge = Number(data.service_charge);
//   const discount = Number(data.discount);
//   const booking_fee = Number(data.booking_fee);
//   const vat = Number(data.vat);
//   const security_deposit = Number(data.security_deposit);
// const eviction_security_deposit = Number(data.eviction_security_deposit);
//   return (
//     +rent +
//     +service_charge +
//     +discount +
//     +vat +
//     +security_deposit +
// +eviction_security_deposit +
//     +booking_fee
//   );
// }

export function formatReadbleDate(date) {
  return moment(date).format("MMM DD, YYYY");
}

export function truncateText(text, length) {
  return text.substring(0, length) + "...";
}

// Password util
export function passwordLengthAboveEight(password) {
  return password.toString().length >= 8;
}

export function passwordIncludesOneNumber(password) {
  return /\d/.test(password.toString());
}

export function passwordIncludesOneSpecialCharacter(password) {
  return /[*@!#%&()^~{}$]+/.test(password.toString());
}

export function passwordIncludesOneUppercase(password) {
  return /[A-Z]+/.test(password.toString());
}

export function passwordStrengthCalculator(password) {
  let passwordCount = 0;

  if (passwordLengthAboveEight(password)) {
    passwordCount = passwordCount + 25;
  }

  if (password && passwordIncludesOneUppercase(password)) {
    passwordCount = passwordCount + 25;
  }

  if (password && passwordIncludesOneNumber(password)) {
    passwordCount = passwordCount + 25;
  }

  if (password && passwordIncludesOneSpecialCharacter(password)) {
    passwordCount = passwordCount + 25;
  }

  return passwordCount;
}

// Password util



// WEBPACK FOOTER //
// ./src/utils/index.js